<landing *ngIf="(homeComponent$ | async) === 'landing'"></landing>
<homepage *ngIf="(homeComponent$ | async) === 'home'"></homepage>
